const TextPlaceholder = ({ numOfLines }) => {
  return (
    <div className="pulse-animate flex-col items-center mt-2 pb-2 border-b-2 border-gray-200">
      <div className="rounded h-4 w-full mr-2 mb-2 bg-gray-400"></div>
      <div className="rounded h-4 w-40 mr-2 bg-gray-400"></div>
    </div>
  );
};

export default TextPlaceholder;
